const INITIAL_STATE = {
  clicked: false,
}

export default function faqReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_CLICKED_FAQ':
      return {
        ...state,
        clicked: action.clicked
      }

    default:
      return state;
  }
}
